import { Sparkles, BarChart2, Clock, Flame, Star } from 'lucide-react';

export const USER_COLORS = [
  'oklch(0.72 0.155 48)',  // apricot
  'oklch(0.74 0.165 150)', // spring green
  'oklch(0.68 0.145 242)', // cobalt
  'oklch(0.75 0.15 95)',   // gold
  'oklch(0.72 0.16 190)',  // teal
  'oklch(0.72 0.15 300)',  // violet
  'oklch(0.72 0.16 340)',  // magenta
  'oklch(0.74 0.14 70)',   // amber
];

export const getUserColor = (user, allUserIds) => {
  if (user?.color) return user.color;
  const idx = allUserIds.indexOf(user.id);
  return USER_COLORS[idx % USER_COLORS.length];
};

export const RANGES = [
  { label: 'Last 7 Days', days: 7 },
  { label: 'Last 30 Days', days: 30 },
  { label: 'Last 90 Days', days: 90 },
];

export const METRICS = [
  { key: 'points', label: 'Points', icon: Sparkles, unit: ' pts' },
  { key: 'count', label: 'Chores Done', icon: BarChart2, unit: ' chores' },
  { key: 'minutes', label: 'Minutes', icon: Clock, unit: ' min' },
  { key: 'difficulty', label: 'Difficulty Score', icon: Flame, unit: '' },
  { key: 'grade', label: 'Avg Grade', icon: Star, unit: '/5' },
];

export const PAGE_SIZE = 10;
